// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  text-align: center;
}

.table-th {
  background-color: #b4ecfc;
}

.table-th th {
  padding: 10px;
}

.table-tr {
  background-color: #e5f9ff;
}

.table-tr td {
  padding: 10px;
}

.uploaded-files {
  margin: 0 auto;
  width: fit-content;
}

.pagination {
  margin-top: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.pagination button {
  font-size: large;
  border: none;
  padding: 8px;
  margin: 0 10px;
  border-radius: 7px;
  cursor: pointer;
}

.pagination button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

.btn {
  font-size: large;
  border: none;
  padding: 8px;
  border-radius: 7px;
  font-weight: 400;
}

.refresh {
  background-color: rgb(190, 240, 183);
  display: flex;
}

.live {
  background-color: rgb(250, 199, 198);
  display: flex;
}

.refresh:hover {
  background-color: #d2e7d0;
}

.input-container {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
}

input[type="file"] {
  display: none;
}

.custom-file-upload {
  border: 1px solid #ccc;
  display: inline-block;
  border-radius: 7px;
  padding: 6px 12px;
  cursor: pointer;
}

.custom-file-upload:hover{
  background-color: #b4ecfc;
}

.upload,
.back,
.grammerbtn,
.pagination-btn {
  background-color: #b4ecfc;
  margin: 10px;
}

.view {
  cursor: pointer;
  display: flex;
  align-items: center;
  text-align: center;
  gap: 7px;
}

.viewType {
  font-weight: 500;
  font-size: larger;
}

.diarised-speakers {
  display: flex;
  margin: 20px;
  text-align: left;
}

.diarised-speakers .speaker {
  margin: 0px 10px;
}

.btn-sp {
  background-color: #76bcf1;
  color: white;
  padding: 5px;
  border-radius: 7px;
  text-align: center;
}

.transcript {
  background-color: #e4f3f7;
  padding: 50px;
  margin: 20px;
}

.title-transcript {
  font-size: larger;
  font-weight: 600;
}

.uploaded-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.uploaded-transcription {
  font-size: larger;
  font-weight: 600;
}


.upload-new-file {
  font-size: 22px;
  font-weight: 800;
}

.grammer{
  text-align: start;
  background-color: #e4f3f7;
  padding: 50px;
  margin: 20px;
}

.cleanup {
  font-size: 34px;
  margin: 10px;
  font-weight: 500;
}

.msg{
  font-size: 24px;
  margin: 10px;
  font-weight: 600;
  text-align: center;
}


.btns{
  display: flex;
  gap:10px;
}


.countdown{
  background-color: #e4f3f7;
  padding: 6px;
  border-radius: 7px;
  font-size: larger;
  font-weight: 700;
  width: fit-content;
}

.status-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin: 0 50px;
}
.live-container1{
  display: flex;
  gap: 10px;
  align-items: center;
  justify-content: right;
}


.status{
  font-weight: 600;
  font-size: larger;
}


.transcript-live{
  background-color: #e4f3f7;
  margin: 20px;
  padding: 30px;
  border-radius: 7px;
  font-weight: 500;
}


.convesation-live{
  font-size: 21px;
  margin-bottom: 20px;
  font-weight: 600;
}


.input-container {
  display: flex;
  flex-direction: column;
  margin-bottom: 20px; 
}

p,h1,h2,h3,h4{
  color: #213555;
}
.input-label {
  font-weight: bold; 
  margin-bottom: 8px; 
  color: #213555;
}

.input-textarea {
  width: 90%; /* Full width */
  height: 300px; /* Set a fixed height */
  padding: 10px; /* Padding inside the textarea */
  border: 1px solid #ccc; /* Border style */
  border-radius: 4px; /* Rounded corners */
  font-size: 13px; /* Font size */
  resize: none; /* Disable resizing */
}


.input-generate{
  justify-content: center;
  align-items: center;
  display: flex;
  gap: 10px;
}


.input-generate input, .input-generate label {
  font-size: 22px;
}


.input-check, .input-config {
  display: flex;
  margin: 10px;
}`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,aAAa;AACf;;AAEA;EACE,oCAAoC;EACpC,aAAa;AACf;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;;EAIE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;;;AAGA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,yBAAyB;EACzB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;;AAGA;EACE,aAAa;EACb,QAAQ;AACV;;;AAGA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,cAAc;AAChB;AACA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,sBAAsB;AACxB;;;AAGA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;;AAGA;EACE,yBAAyB;EACzB,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;;;AAGA;EACE,eAAe;EACf,mBAAmB;EACnB,gBAAgB;AAClB;;;AAGA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,UAAU,EAAE,eAAe;EAC3B,aAAa,EAAE,uBAAuB;EACtC,aAAa,EAAE,gCAAgC;EAC/C,sBAAsB,EAAE,iBAAiB;EACzC,kBAAkB,EAAE,oBAAoB;EACxC,eAAe,EAAE,cAAc;EAC/B,YAAY,EAAE,qBAAqB;AACrC;;;AAGA;EACE,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,SAAS;AACX;;;AAGA;EACE,eAAe;AACjB;;;AAGA;EACE,aAAa;EACb,YAAY;AACd","sourcesContent":[".App {\n  text-align: center;\n}\n\n.table-th {\n  background-color: #b4ecfc;\n}\n\n.table-th th {\n  padding: 10px;\n}\n\n.table-tr {\n  background-color: #e5f9ff;\n}\n\n.table-tr td {\n  padding: 10px;\n}\n\n.uploaded-files {\n  margin: 0 auto;\n  width: fit-content;\n}\n\n.pagination {\n  margin-top: 20px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.pagination button {\n  font-size: large;\n  border: none;\n  padding: 8px;\n  margin: 0 10px;\n  border-radius: 7px;\n  cursor: pointer;\n}\n\n.pagination button:disabled {\n  background-color: #ccc;\n  cursor: not-allowed;\n}\n\n.btn {\n  font-size: large;\n  border: none;\n  padding: 8px;\n  border-radius: 7px;\n  font-weight: 400;\n}\n\n.refresh {\n  background-color: rgb(190, 240, 183);\n  display: flex;\n}\n\n.live {\n  background-color: rgb(250, 199, 198);\n  display: flex;\n}\n\n.refresh:hover {\n  background-color: #d2e7d0;\n}\n\n.input-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n}\n\ninput[type=\"file\"] {\n  display: none;\n}\n\n.custom-file-upload {\n  border: 1px solid #ccc;\n  display: inline-block;\n  border-radius: 7px;\n  padding: 6px 12px;\n  cursor: pointer;\n}\n\n.custom-file-upload:hover{\n  background-color: #b4ecfc;\n}\n\n.upload,\n.back,\n.grammerbtn,\n.pagination-btn {\n  background-color: #b4ecfc;\n  margin: 10px;\n}\n\n.view {\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  text-align: center;\n  gap: 7px;\n}\n\n.viewType {\n  font-weight: 500;\n  font-size: larger;\n}\n\n.diarised-speakers {\n  display: flex;\n  margin: 20px;\n  text-align: left;\n}\n\n.diarised-speakers .speaker {\n  margin: 0px 10px;\n}\n\n.btn-sp {\n  background-color: #76bcf1;\n  color: white;\n  padding: 5px;\n  border-radius: 7px;\n  text-align: center;\n}\n\n.transcript {\n  background-color: #e4f3f7;\n  padding: 50px;\n  margin: 20px;\n}\n\n.title-transcript {\n  font-size: larger;\n  font-weight: 600;\n}\n\n.uploaded-head {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.uploaded-transcription {\n  font-size: larger;\n  font-weight: 600;\n}\n\n\n.upload-new-file {\n  font-size: 22px;\n  font-weight: 800;\n}\n\n.grammer{\n  text-align: start;\n  background-color: #e4f3f7;\n  padding: 50px;\n  margin: 20px;\n}\n\n.cleanup {\n  font-size: 34px;\n  margin: 10px;\n  font-weight: 500;\n}\n\n.msg{\n  font-size: 24px;\n  margin: 10px;\n  font-weight: 600;\n  text-align: center;\n}\n\n\n.btns{\n  display: flex;\n  gap:10px;\n}\n\n\n.countdown{\n  background-color: #e4f3f7;\n  padding: 6px;\n  border-radius: 7px;\n  font-size: larger;\n  font-weight: 700;\n  width: fit-content;\n}\n\n.status-container {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin: 0 50px;\n}\n.live-container1{\n  display: flex;\n  gap: 10px;\n  align-items: center;\n  justify-content: right;\n}\n\n\n.status{\n  font-weight: 600;\n  font-size: larger;\n}\n\n\n.transcript-live{\n  background-color: #e4f3f7;\n  margin: 20px;\n  padding: 30px;\n  border-radius: 7px;\n  font-weight: 500;\n}\n\n\n.convesation-live{\n  font-size: 21px;\n  margin-bottom: 20px;\n  font-weight: 600;\n}\n\n\n.input-container {\n  display: flex;\n  flex-direction: column;\n  margin-bottom: 20px; \n}\n\np,h1,h2,h3,h4{\n  color: #213555;\n}\n.input-label {\n  font-weight: bold; \n  margin-bottom: 8px; \n  color: #213555;\n}\n\n.input-textarea {\n  width: 90%; /* Full width */\n  height: 300px; /* Set a fixed height */\n  padding: 10px; /* Padding inside the textarea */\n  border: 1px solid #ccc; /* Border style */\n  border-radius: 4px; /* Rounded corners */\n  font-size: 13px; /* Font size */\n  resize: none; /* Disable resizing */\n}\n\n\n.input-generate{\n  justify-content: center;\n  align-items: center;\n  display: flex;\n  gap: 10px;\n}\n\n\n.input-generate input, .input-generate label {\n  font-size: 22px;\n}\n\n\n.input-check, .input-config {\n  display: flex;\n  margin: 10px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
